export enum VitalSignChartFields {
  SysBloodPressure1 = 'sysBloodPressure1',
  DiasBloodPressure1 = 'diasBloodPressure1',
  SysBloodPressure2 = 'sysBloodPressure2',
  DiasBloodPressure2 = 'diasBloodPressure2',
  Pulse1 = 'pulse1',
  Pulse2 = 'pulse2',
  Temperature1 = 'temperature1',
  Temperature2 = 'temperature2',
  Breath1 = 'breath1',
  Breath2 = 'breath2',
}

export const VitalSignChartFormDefaultValues = {
  [VitalSignChartFields.SysBloodPressure1]: undefined,
  [VitalSignChartFields.DiasBloodPressure1]: undefined,
  [VitalSignChartFields.SysBloodPressure2]: undefined,
  [VitalSignChartFields.DiasBloodPressure2]: undefined,
  [VitalSignChartFields.Pulse1]: undefined,
  [VitalSignChartFields.Pulse2]: undefined,
  [VitalSignChartFields.Temperature1]: undefined,
  [VitalSignChartFields.Temperature2]: undefined,
  [VitalSignChartFields.Breath1]: undefined,
  [VitalSignChartFields.Breath2]: undefined,
};
